import React, { useState } from "react";

export const useCopyableState = (initialLabel: string) => {
  const [isCopied, setIsCopied] = useState(false);
  const [isHovered, setIsHovered] = useState(false);

  const handleCopy = (e?: React.MouseEvent) => {
    e?.stopPropagation();
    e?.preventDefault();
    if (!initialLabel) return;

    navigator.clipboard.writeText(initialLabel).then(() => {
      setIsCopied(true);
      setTimeout(() => setIsCopied(false), 2000);
    });
  };

  return {
    isCopied,
    isHovered,
    setIsHovered,
    handleCopy,
  };
};
